import axios from "axios";
import { hostServer } from "./consts/host";

export const setProbers = probers => ({
  type: "SET_PROBERS",
  probers
});

export const startSetProbers = () => {
  return async (dispatch, getState) => {
    const json = {
      headers: {
        Authorization: `Token ${getState().auth.uid}`
      }
    };
    const res = await axios.get(`${hostServer}/api/v1/probers/`, json);
    const probers = [];
    res.data.results.forEach(prober => {
      probers.push(prober);
    });
    dispatch(setProbers(probers));
  };
};
